import { render, staticRenderFns } from "./SupplyAgreement.vue?vue&type=template&id=1d183b97&scoped=true&"
import script from "./SupplyAgreement.vue?vue&type=script&lang=js&"
export * from "./SupplyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SupplyAgreement.vue?vue&type=style&index=0&id=1d183b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d183b97",
  null
  
)

export default component.exports